<template lang="html">
  <component :is="tag" class="text__desc" :class="{ bold }">
    <!-- @slot Безымянный слот. Используется для вставки текста-->
    <slot/>
  </component>
</template>

<script>
export default {
  name: 'bimTextDesc',
  props: {
    /**
     * Добавить жирность
     */
    bold: {
      type: Boolean,
      default: false
    },
    /**
     * Тег обёртки
     */
    tag: {
      type: String,
      default: 'div'
    },
    /**
     * Изменять размер шрифта в моб версии
     * @values true, false
     */
    adaptive: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.text__desc {
  font-size: 12px;
  font-weight: normal;
  line-height: 1.67;
  letter-spacing: normal;
}

.text__desc.bold {
  font-weight: bold;
}
</style>
